import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { KsefAdminApiService } from 'shared/services/api/ksef-admin.api.service';
import { ValidationErrorDetailsDialogComponent } from '../../dialogs/validation-error-details-dialog/validation-error-details-dialog.component';

@Component({
  selector: 'app-validation-errors-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatDialogModule
  ],
  templateUrl: './validation-errors-list.component.html',
  styleUrls: ['./validation-errors-list.component.scss']
})
export class ValidationErrorsListComponent implements OnInit {
  public displayedColumns: string[] = ['timestamp', 'documentNumber', 'user', 'errorCode', 'errorMessage', 'actions'];
  public dataSource: any[] = [];
  public isLoading = true;
  public totalCount = 0;
  public limit = 50;
  public skip = 0;

  constructor(
    private ksefAdminApi: KsefAdminApiService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadValidationErrors();
  }

  loadValidationErrors(): void {
    this.isLoading = true;
    
    this.ksefAdminApi.getValidationErrors({
      limit: this.limit,
      skip: this.skip
    }).subscribe({
      next: (response) => {
        this.dataSource = response.data.validationErrors || [];
        this.totalCount = response.data.pagination?.total || 0;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('❌ Error loading validation errors:', error);
        this.isLoading = false;
      }
    });
  }

  openDetailsDialog(validationError: any): void {
    this.dialog.open(ValidationErrorDetailsDialogComponent, {
      data: validationError,
      width: '900px',
      maxHeight: '90vh'
    });
  }

  refresh(): void {
    this.skip = 0;
    this.loadValidationErrors();
  }
}

